module.exports = __webpack_public_path__ + "img/app-store-link.e9b6110a.svg";